import React from 'react';

export function VerticalDividerIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <svg className={className}
      width="1" height="24" viewBox="0 0 1 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="1" height="24" rx="0.5" fill="#E1E5E8" />
    </svg>
  );
}